import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/components/submitedCompletionFilter/SubmitedCompletionFilter.module.scss';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';
import Slider from 'components/common/Slider/Slider';

import { IActivityType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: IActivityType[];
    isSelected?: boolean;
}

export const SubmittedCompletionFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const getValue = (value) => {
        if (!value || value.length === 0) {
            return [0, 100];
        }
        return value;
    };

    return isSelected ? (
        <div className={classes.SubmitedCompletionWrapper}>
            <span className={classes.title}>Submitted Completion</span>
            <div data-testid={'battlecards-filters-submittedCompletion-slider'} className={classes.sliderWrapper}>
                <Controller
                    render={({ field }) => (
                        <Slider
                            id={'battlecards-filters-submittedCompletion-slider'}
                            {...field}
                            value={getValue(value)}
                            step={10}
                            min={0}
                            max={100}
                            defaltValue={[0, 100]}
                            valueLabelDisplay={'on'}
                            onChangeCommitted={(_e, value) => {
                                methods?.setValue(name, value);
                                handleFilters?.();
                            }}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    ) : null;
};
